'use strict';

const AdyenCheckout = require('@adyen/adyen-web');

const exportFunctions = {
  init: function (paymentMethodResponse, container, selectedPaymentMethod, config, onSubmitCallback, onAdditionalDetailsCallback) {
    const configuration = {
      locale: config.locale,
      environment: config.environment,
      clientKey: config.clientKey,
      paymentMethodsResponse: paymentMethodResponse,
      selectedPaymentMethod: selectedPaymentMethod,
    };

    const checkout = new AdyenCheckout(configuration);
    checkout.create('paypal', {
      environment: config.environment,
      countryCode: config.countryCode, // Only needed for test. This will be automatically retrieved when you are in production.
      amount: {
        currency: config.priceCurrency,
        value: config.priceAmount
      },
      style: {
        color: 'black',
        shape: 'rect',
        label: 'checkout',
        tagline: false
      },
      onSubmit: onSubmitCallback,
      onCancel: (data, component) => {
        // Sets the status of the component when a PayPal payment is cancelled. Return to the initial state.
        component.setStatus('ready');
      },
      onError: (error, component) => {
        // Sets the status of the component when an error occurs. Return to the initial state.
        component.setStatus('ready');
      },
      onAdditionalDetails: onAdditionalDetailsCallback
    }).mount(container);
  },
};

module.exports = exportFunctions;
